<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'
import { stat } from 'fs';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        filter: function(){
            $('#spinner').modal('toggle');
                let payload = this;
                payload.items = [];
                setTimeout(async function(){
                    let gasstation = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), payload.filters, `${Endpoints.gasstation.search}`));
                    if (gasstation.status == 200){
                        payload.items = gasstation.data.results;
                        $('#spinner').modal('toggle');
                    }
                }, 100);
        },
        onChange: function(){
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        getPageNumbers: function(){
            return this.items.length/10;
        },
         fetchData(){
            this.json_data = this.items;
            return this.json_data;
    
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
